<script>
import { get } from 'lodash';
export default {
  data() {
    return { }
  },
  methods: { },
  computed: {
    canShow() {
      const mainContent = globalState.pageModel.name_to_content[globalState.pageModel.main_content_name];
      const isSme = (!!mainContent.slug && mainContent.name.includes("sme")) || (mainContent["parent_names"] || []).includes("target-sme");
      const isSoho = (!!mainContent.slug && mainContent.name.includes("soho")) || (mainContent["parent_names"] || []).includes("target-soho");
      return isSme || isSoho;
    },
    href() {
      return get(Fandom.retrieveFromGlobalState('soho_contact_stripe'),  ['button', 'url'], '/');
    }
  }
};
</script>

<template>
	<div class="p-3" chat-link-component v-if="canShow">
    <a :href="href" class="h-100 w-100 d-flex justify-content-center align-items-center">
      <i class="fal fa-comments"></i>
    </a>
	</div>
</template>

<style lang="scss" scoped>
[chat-link-component] {
  position: fixed;
  width: 7rem;
  height: 7rem;
  bottom: 0;
  right: 0;

  & > a {
    border-radius: 100%;
    background-color: $primary;
    color: $white;
    transition: box-shadow .25s;

    & > i {
      font-size: 2rem;
    }

    &:hover {
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.5);
    }
  }
}
</style>